import listing1 from '../assets/images/listing/vizcachas1.jpg'
import listing2 from '../assets/images/listing/vizcachas2.jpg'
import listing3 from '../assets/images/listing/3.jpg'
import listing4 from '../assets/images/listing/4.jpg'
import listing5 from '../assets/images/listing/5.jpg'
import listing6 from '../assets/images/listing/6.jpg'
import listing7 from '../assets/images/listing/7.jpg'
import listing8 from '../assets/images/listing/8.jpg'
import listing9 from '../assets/images/listing/9.jpg'
import listing10 from '../assets/images/listing/10.jpg'
import listing11 from '../assets/images/listing/11.jpg'
import listing12 from '../assets/images/listing/12.jpg'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'
import client7 from '../assets/images/client/07.jpg'

import blog1 from '../assets/images/blog/1.jpg'
import blog2 from '../assets/images/blog/2.jpg'
import blog3 from '../assets/images/blog/3.jpg'
import blog4 from '../assets/images/blog/4.jpg'
import blog5 from '../assets/images/blog/5.jpg'
import blog6 from '../assets/images/blog/6.jpg'
import blog7 from '../assets/images/blog/7.jpg'
import blog8 from '../assets/images/blog/8.jpg'
import blog9 from '../assets/images/blog/9.jpg'

import payment1 from '../assets/images/payments/visa.jpg'
import payment2 from '../assets/images/payments/american-express.jpg'
import payment3 from '../assets/images/payments/discover.jpg'
import payment4 from '../assets/images/payments/mastercard.jpg'

import img_paine01 from '../assets/images/listing/Torres-del-paine.jpg';

import image1 from '../assets/images/listing/vizcachas1.jpg';
import image2 from '../assets/images/listing/vizcachas2.jpg';
import image3 from '../assets/images/listing/vizcachas5.png';
import image4 from '../assets/images/listing/vizcachas4.png';
import image5 from '../assets/images/listing/vizcachas3.jpg';

import {FiLinkedin,FiFacebook,FiInstagram,FiTwitter,FiClock,FiActivity, FiUsers, FiGlobe,FiDollarSign,FiYoutube,FiHelpCircle,FiBookmark,FiSettings,FiGithub,FiGitlab} from "../assets/icons/vander"

// LEGACY: fetch a un dominio ajeno (cmsystem.cl) NEUTRALIZADO por seguridad
// (fuga de datos a un origen externo). Ninguna página viva usa
// cargarProductos/productosCache; se conserva la firma para no romper imports.
export let productosCache = [];

export async function cargarProductos() {
    productosCache = [];
    return productosCache;
}


// LEGACY: datos de plantilla usados solo por páginas NO ruteadas (index-two..five,
// top-destination-two, user-*, helpcenter, blog-*, tour-detail-two, etc.).
// Se conservan para no romper imports de esos archivos huérfanos, pero no
// alimentan ninguna página viva. Los exports vivos son: footerCompany,
// footerSocial, ClientData, blogData (index), teamData/placeImage (aboutus).
export const topDestination = [
    {
        image:listing1,
        place:'Rome, Italy',
        hotels:'3 Hotels'
    },
    {
        image:listing2,
        place:'Singapore',
        hotels:'3 Hotels'
    },
    {
        image:listing3,
        place:'Paris, France',
        hotels:'3 Hotels'
    },
    {
        image:listing4,
        place:'Goa, India',
        hotels:'3 Hotels'
    },
    {
        image:listing5,
        place:'Whistler, Canada',
        hotels:'3 Hotels'
    },
    {
        image:listing6,
        place:'Lumpur, Malaysia',
        hotels:'3 Hotels'
    },
    {
        image:listing7,
        place:'Sydney, Australia',
        hotels:'3 Hotels'
    },
    {
        image:listing8,
        place:'Virginia Beach',
        hotels:'3 Hotels'
    },
]
export const tourDetailAbout = [
    {
        icon: FiClock,
        name:'Duración',
        title:'5 Horas'
    },
    {
        icon: FiActivity,
        name:'Type',
        title:'Aventura'
    },
    {
        icon: FiUsers,
        name:'Grupos:',
        title:'20 Personas'
    },
    {
        icon: FiGlobe,
        name:'Lenguaje',
        title:'Español'
    },
    {
        icon: FiDollarSign,
        name:'CLP$50.000 Persona',
        title:'1 Día'
    },
]
//mysql -u root -p -e "SOURCE consultaRm.sql;" smconect_smconectav2 | sed 's/\t/","/g;s/^/"/;s/$/"/' > reporte_consultaRm.csv

export const packages = [
    {
        id: 1,
        image: listing1,
        tagText: '10% Off',
        place: 'Chile',
        title: 'Mirador Local Las Vizcachas, Rari',
        amount: '$58 / Día',
        price: 58000,
        currency: 'CLP',
        heroImage: listing1,
        mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31870.732227859546!2d-71.477!3d-35.744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96659c7f5a6a77a3%3A0x5a3b58f42d806021!2sRari%2C%20Colb%C3%BAn%2C%20Maule!5e0!3m2!1ses-419!2scl!4v1712444400000!5m2!1ses-419!2scl',
        description: [
            "Una alternativa para llegar hasta el Cerro Las Vizcachas desde el sector de Rari. Se le conoce como \"El camino de las raíces\", debido a su último ascenso, donde abundan las raíces de grandes árboles. Transcurre la mayor parte del tiempo bajo hermosos bosques nativos y, desde su parte final, se tienen buenas panorámicas del sector aledaño.",
            "Aunque la ruta es considerablemente más larga y confusa que la que sube por el sector Los Rabones, es muy visitada por ciclistas, ya que la amplitud de las sendas y la pendiente la hacen adecuada para mountain bike. Se recomienda el uso de GPS, pues la abundancia de desvíos puede ocasionar extravíos del sendero principal.",
            "La ruta presenta un interesante componente cultural, pues se transita principalmente por antiguos caminos de explotación de carbón artesanal, una actividad que aún subsiste, aunque comienza a ser desplazada por la presencia de forestales."
        ],
        images: [image1, image2, image3, image4, image5],
        tourDetailAbout: [
            {
                icon: FiClock,
                name: 'Duración',
                title: '5 Horas'
            },
            {
                icon: FiActivity,
                name: 'Tipo',
                title: 'Aventura'
            },
            {
                icon: FiUsers,
                name: 'Grupos',
                title: '20 Personas'
            },
            {
                icon: FiGlobe,
                name: 'Idioma',
                title: 'Español'
            },
            {
                icon: FiDollarSign,
                name: 'US$50 por persona',
                title: '1 Día'
            }
        ],
        faqData: [
            {
                id: 1,
                title: '¿Cómo funciona?',
                desc: 'Contáctanos y te explicamos el detalle del recorrido, horarios y punto de encuentro.'
            },
            {
                id: 2,
                title: '¿Necesito un diseñador para usar Chile-Turismo.cl?',
                desc: 'Contáctanos y te explicamos el detalle del recorrido, horarios y punto de encuentro.'
            },
            {
                id: 3,
                title: '¿Qué debo hacer para comenzar a vender?',
                desc: 'Contáctanos y te explicamos el detalle del recorrido, horarios y punto de encuentro.'
            },
            {
                id: 4,
                title: '¿Qué sucede cuando recibo un pedido?',
                desc: 'Contáctanos y te explicamos el detalle del recorrido, horarios y punto de encuentro.'
            },
            {
                id: 5,
                title: '¿Cómo funciona?',
                desc: 'Contáctanos y te explicamos el detalle del recorrido, horarios y punto de encuentro.'
            }
        ]
    },
    {
        id: 2,
        image: img_paine01,
        tagText: 'Nuevo',
        place: 'Chile',
        title: 'Parque Nacional Torres del Paine',
        amount: 'CLP$120.000 / Día',
        price: 120000,
        currency: 'CLP',
        heroImage: 'https://images.unsplash.com/photo-1508264165352-258859e62245?auto=format&fit=crop&w=1600&q=80',
        mapEmbed: 'https://www.openstreetmap.org/export/embed.html?bbox=-73.5%2C-51.4%2C-72.5%2C-50.8&layer=mapnik&marker=-51.148%2C-72.999',
        description: [
            "Explora las icónicas Torres del Paine con miradores únicos, lagos turquesa y los macizos de granito que han hecho famoso al parque en todo el mundo.",
            "El circuito incluye navegación por el Lago Grey para ver de cerca los témpanos del glaciar, caminatas suaves y tramos con mayor pendiente para quienes buscan desafío.",
            "La fauna es parte del espectáculo: guanacos, zorros y, con suerte, cóndores sobrevolando los valles y miradores panorámicos.",
            "Al final del día, disfruta de la gastronomía patagónica con cordero al palo y calafate sour en refugios o estancias locales."
        ],
        images: [
            'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1505852679233-d9fd70aff56d?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80'
        ],
        tourDetailAbout: [
            {
                icon: FiClock,
                name: 'Duración',
                title: '8 Horas'
            },
            {
                icon: FiActivity,
                name: 'Tipo',
                title: 'Trekking / Navegación'
            },
            {
                icon: FiUsers,
                name: 'Grupos',
                title: '12 Personas'
            },
            {
                icon: FiGlobe,
                name: 'Idioma',
                title: 'Español / Inglés'
            },
            {
                icon: FiDollarSign,
                name: 'Incluye',
                title: 'Traslados + Box lunch'
            }
        ],
        faqData: [
            {
                id: 1,
                title: '¿El tour se suspende por clima?',
                desc: 'Puede reprogramarse según viento y lluvia; avisamos con anticipación si hay cierre de senderos.'
            },
            {
                id: 2,
                title: '¿Requiere experiencia previa?',
                desc: 'Hay rutas para principiantes y tramos exigentes; te ayudamos a elegir el nivel adecuado.'
            },
            {
                id: 3,
                title: '¿Qué debo llevar?',
                desc: 'Ropa en capas, cortaviento, protector solar, botella reutilizable y calzado de trekking.'
            },
            {
                id: 4,
                title: '¿Incluye entradas al parque?',
                desc: 'Podemos gestionar el ticket CONAF; consúltanos para incorporarlo en la reserva.'
            },
            {
                id: 5,
                title: '¿Hay opciones vegetarianas?',
                desc: 'Sí, el box lunch se adapta a preferencias o restricciones avisando con anticipación.'
            }
        ]
    },
    {
        id: 3,
        image: 'https://images.unsplash.com/photo-1526772662000-3f88f10405ff?auto=format&fit=crop&w=1200&q=80',
        tagText: 'Promo',
        place: 'Argentina',
        title: 'Argentina + Termas Cacheuta',
        amount: 'CLP$189.990',
        price: 189990,
        currency: 'CLP',
        heroImage: 'https://images.unsplash.com/photo-1526772662000-3f88f10405ff?auto=format&fit=crop&w=1600&q=80',
        mapEmbed: 'https://www.openstreetmap.org/export/embed.html?bbox=-69.12%2C-32.99%2C-69.03%2C-32.93&layer=mapnik&marker=-32.966%2C-69.08',
        description: [
            "🌟 ¡Escapada única a Mendoza con Termas de Cacheuta! Combina relajo, naturaleza y sabores auténticos.",
            "Incluye Embalse Potrerillos con desayuno de montaña, ticket a las termas con pozas de distintas temperaturas, puentes colgantes y panorámicas.",
            "Recorrido por Mendoza ciudad: Plaza principal y visita a la famosa Chocoleza; cierre en el barrio bohemio Arístides.",
            "Promoción especial: $189.990 (desde 3 años). Reserva con 50% y paga el resto en efectivo el día del viaje.",
            "Salidas: viernes, regreso domingo. Diciembre 26-28 y todos los viernes en enero/febrero (consulta disponibilidad).",
            "Extras opcionales: Almuerzo parrillada libre $19.990 (efectivo), Batas de baño $8.000. Llevar CI/ Pasaporte; menores con permiso notarial."
        ],
        images: [
            'https://images.unsplash.com/photo-1526772662000-3f88f10405ff?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1508264165352-258859e62245?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1505852679233-d9fd70aff56d?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
            'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80'
        ],
        tourDetailAbout: [
            { icon: FiClock, name: 'Duración', title: '3 días / 2 noches' },
            { icon: FiActivity, name: 'Tipo', title: 'Relajo + City tour' },
            { icon: FiUsers, name: 'Grupos', title: '25 Personas' },
            { icon: FiGlobe, name: 'Idioma', title: 'Español' },
            { icon: FiDollarSign, name: 'Promoción', title: 'Reserva con 50% y paga resto en efectivo' }
        ],
        faqData: [
            { id: 1, title: '¿Qué debo llevar?', desc: 'CI o Pasaporte, ropa de baño, toalla o bata (opcional $8.000), bloqueador y calzado cómodo.' },
            { id: 2, title: '¿Las termas están incluidas?', desc: 'Sí, el ticket de ingreso a Termas de Cacheuta está incluido en el paquete.' },
            { id: 3, title: '¿El almuerzo está incluido?', desc: 'No, es un extra opcional: parrillada libre por $19.990 pagada en efectivo.' },
            { id: 4, title: '¿Se puede pagar en cuotas?', desc: 'Puedes reservar con el 50% y saldar en efectivo el día del viaje.' },
            { id: 5, title: '¿Horarios de salida?', desc: 'Salida viernes, regreso domingo; salidas confirmadas 26-28 diciembre y todos los viernes de enero y febrero (confirmar cupo).' }
        ]
    },
    {
        id:4,
        image:listing4,
        place:'USA',
        title:'Museum of Modern Art',
        amount:'$ 58 / Day'
    },
    {
        id:5,
        image:listing5,
        place:'Bali',
        title:'Peek Mountain View',
        amount:'$ 58 / Day'
    },
    {
        id:6,
        image:listing6,
        tagText:'25% Off',
        place:'Bangkok',
        title:'Hot Baloon Journey',
        amount:'$ 58 / Day'
    },
    {
        id:7,
        image:listing7,
        place:'Singapore',
        title:'Orca Camp Kayaking Trip',
        amount:'$ 58 / Day'
    },
    {
        id:8,
        image:listing8,
        tagText:'20% Off',
        place:'Thailand',
        title:'Caño Cristales River Trip',
        amount:'$ 58 / Day'
    },
    {
        id:9,
        image:listing9,
        place:'Pattaya',
        title:'Osa Peninsula to Dominical',
        amount:'$ 58 / Day'
    },
    {
        id:10,
        image:listing10,
        place:'Lakshadweep',
        title:'History of The Emporer',
        amount:'$ 58 / Day'
    },
    {
        id:11,
        image:listing11,
        place:'Paris',
        title:'Wildness of Paris',
        amount:'$ 58 / Day'
    },
    {
        id:12,
        image:listing12,
        place:'London',
        title:'The Hills and Mountains',
        amount:'$ 58 / Day'
    },
]

// NOTA: testimonios neutrales de marcador de posición (placeholder).
// Reemplazar por reseñas reales de clientes cuando estén disponibles.
export const ClientData = [
    {
        image:client1,
        desc:'"Excelente organización y guías muy atentos. Repetiríamos sin dudarlo."',
        name:'Cliente verificado',
        possition:'Viajero'
    },
    {
        image:client2,
        desc:'"El proceso de reserva y pago fue simple y claro. Todo salió tal como se ofreció."',
        name:'Cliente verificado',
        possition:'Viajera'
    },
    {
        image:client3,
        desc:'"Paisajes increíbles y una experiencia muy bien coordinada de principio a fin."',
        name:'Cliente verificado',
        possition:'Viajero'
    },
]

export const blogData = [
    {
        id:1,
        image:blog1,
        date:'13th Sep 2024',
        title:'This Spanish city is a feast for the eyes: Chile-Turismo.cl',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Travel'
    },
    {
        id:2,
        image:blog2,
        date:'29th Nov 2024',
        title:'New Zealand’s South Island brims with majestic',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Tour'
    },
    {
        id:3,
        image:blog3,
        date:'29th Dec 2024',
        title:'When you visit the Eternal Rome City: Chile-Turismo.cl',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Tourist'
    },
    {
        id:4,
        image:blog4,
        date:'13th March 2024',
        title:'My Story When I Backpacked Around The World',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Flight'
    },
    {
        id:5,
        image:blog5,
        date:'5th May 2024',
        title:'Organization of accounting at the enterprise',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Arab'
    },
    {
        id:6,
        image:blog6,
        date:'19th June 2024',
        title:'Three of the Best Day Trips to Make from Francisco',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Dubai'
    },
    {
        id:7,
        image:blog7,
        date:'20th June 2024',
        title:'Why Do People Travel ? Reasons People Travel in 2023',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Maldivas'
    },
    {
        id:8,
        image:blog8,
        date:'31st Aug 2024',
        title:'Jungles In Australia: Vermont’s Rugged, Retro Ski Mountain',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'News'
    },
    {
        id:9,
        image:blog9,
        date:'1st Sep 2024',
        title:'Traveller Visiting Ice Cave With Amazing Eye-catching Scenes',
        desc:'This is required when, for example, the final text is not yet available.',
        tag:'Packages'
    },
]

// Sin redes sociales reales verificadas: se dejan vacías para no enlazar
// perfiles ajenos de la plantilla original. Agregar aquí las cuentas
// oficiales de Chile-Turismo.cl cuando existan.
export const footerSocial = []

export const footerCompany = [
    {
        name:'Nosotros',
        link:'/aboutus'
    },
    {
        name:'Contacto',
        link:'/contact'
    },
    {
        name:'Términos y Condiciones',
        link:'/terms'
    },
    {
        name:'Política de Privacidad',
        link:'/privacy'
    },
]

export const placeImage = [
    listing1,listing2,listing3,listing4,listing5,listing6,listing7,listing8,listing9,listing10,listing11,listing2,listing3,listing4
]

export const faqData = [
    {
        id:1,
        title:'How does it work ?',
        desc:'Escríbenos y con gusto resolvemos tu consulta.'
    },
    {
        id:2,
        title:'Do I need a designer to use Chile-Turismo.cl ?',
        desc:'Escríbenos y con gusto resolvemos tu consulta.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'Escríbenos y con gusto resolvemos tu consulta.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'Escríbenos y con gusto resolvemos tu consulta.'
    },
    {
        id:5,
        title:'How does it work ?',
        desc:'Escríbenos y con gusto resolvemos tu consulta.'
    },
]



export const teamData = [
    {
        image:client4,
        name:'Jack John',
        possition:'Agent'
    },
    {
        image:client5,
        name:'Krista John',
        possition:'Agent'
    },
    {
        image:client6,
        name:'Roger Jackson',
        possition:'Agent'
    },
    {
        image:client7,
        name:'Johnny English',
        possition:'Agent'
    },
]

export const paymentData = [
    {
        image:payment1,
        title:'Visa ending in 4578',
        date:'Expires in 13/03/2024'
    },
    {
        image:payment2,
        title:'American Express ending in 4578',
        date:'Expires in 05/05/2024'
    },
    {
        image:payment3,
        title:'Discover ending in 4578',
        date:'Expires in 19/06/2024'
    },
    {
        image:payment4,
        title:'Master Card ending in 4578',
        date:'Expires in 20/06/2024'
    },
]

export const userSocialData = [
    {
        icon:FiTwitter,
        name:'Twitter',
        placeHolder:'Twitter Profile Name',
        desc:'Add your Twitter username (e.g. jesus).'
    },
    {
        icon:FiFacebook,
        name:'Facebook',
        placeHolder:'Facebook Profile Name',
        desc:'Add your Facebook username (e.g. jesus).'
    },
    {
        icon:FiInstagram,
        name:'Instagram',
        placeHolder:'Instagram Profile Name',
        desc:'Add your Instagram username (e.g. jesus).'
    },
    {
        icon:FiLinkedin,
        name:'Linkedin',
        placeHolder:'Linkedin Profile Name',
        desc:'Add your Linkedin username (e.g. jesus).'
    },
    {
        icon:FiYoutube,
        name:'Youtube',
        placeHolder:'Youtube url',
        desc:'Add your Youtube url.'
    },
]

export const helpAbout = [
    {
        icon:FiHelpCircle,
        title:'FAQs',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        link:'/helpcenter-faqs'
    },
    {
        icon:FiBookmark,
        title:'Guides / Support',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        link:'/helpcenter-guides'
    },
    {
        icon:FiSettings,
        title:'Support Request',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        link:'/helpcenter-support'
    },
]

export const guidesData = [
    {
        title:'Getting started',
        subData:[
            'Deciding to purchase','List your space','Landing an experience or adventure','Top uses questions'
        ]
    },
    {
        title:'Your calendar',
        subData:[
            'Pricing & availability','Booking settings','Responding to enquiries & requests','Snoozing or deactivating your listing'
        ]
    },
    {
        title:'Your listings',
        subData:[
            'Updating your listing','Neighbourhoods','Listing photos & photography','Chile-Turismo.cl Plus','API-connected software'
        ]
    },
    {
        title:'How payouts work',
        subData:[
            'Getting paid','Adding payout info','Your payout status','Donations','Taxes'
        ]
    },
    {
        title:'Your reservations',
        subData:[
            'Chile-Turismo.cl safely','Chile-Turismo.cl Experiences and Adventures','Changing a reservation','Cancelling a reservation','Long-term reservations'
        ]
    },
    {
        title:'Reservation help',
        subData:[
            'Help with a reservation or guest','Guest cancellations',
        ]
    },
    {
        title:'Your account',
        subData:[
            'Your profile','Account security','Identification & verifications','Reviews','Superhost status'
        ]
    },
]

export const restrictions = [
    'Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand','Digital Marketing Solutions for Tomorrow','Our Talented & Experienced Marketing Agency','Create your own skin to match your brand'
]

export const blogSocial = [
    FiFacebook,FiInstagram,FiTwitter,FiLinkedin,FiGithub,FiYoutube,FiGitlab
]
